const formatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  minimumFractionDigits: 2,
  style: 'currency',
})

export interface FormatPriceOptions {
  /**
   * Indicates whether the formatted price text should be `'-'` or `'$0.00'` based on the empty price value.
   * If true, it will return `'$0.00'`,
   * otherwise, it will return `'-'`.
   */
  zeroPrice?: boolean
}

// Note: Price should be provided in cents.
export const formatPrice = (cents?: number | string | null, options: FormatPriceOptions = {}) => {
  const { zeroPrice = false } = options

  let centsToFormat: number = typeof cents === 'string' ? parseFloat(cents) : (cents ?? NaN)
  if (!Number.isFinite(centsToFormat)) centsToFormat = 0

  if (!zeroPrice && !centsToFormat) return '-'

  return formatter.format(centsToFormat / 100)
}
